/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import L from "./Lang";
import './AppActions.css';

export default class AppActions extends BaseCom {

    localGoBack = () => {
        if (this.props.onBack)
            this.props.onBack();
        else
            this.goBack();
    }

    render() {
        return <div className="app-actions">
            <div className="app-actions-container">
                {!this.props.noBack && <div>
                    <button
                        type="button"
                        className="btn btn-secondary btn-lg"
                        onClick={this.localGoBack}><L>Go Back</L></button>
                </div>}
                {this.props.containerContent}
                <div className="flex-fill d-flex gap-1 justify-content-end align-items-center">
                    {this.props.children}
                </div>
            </div>
        </div>;
    }
}